export default __webpack_public_path__ + "static/media/premium-logistics-hero-branded.fbee2cf5.jpg";